:host {
  display: inline-block;
  width: 1em;
  height: 1em;
  fill: currentColor;
}

:host(.size-sm) {
  font-size: 16px;
}

:host(.size-md) {
  font-size: 24px;
}

:host(.size-lg) {
  font-size: 32px;
}

svg {
  display: block;
  width: 100%;
  height: 100%;
}
